import * as Menu from '@radix-ui/react-dropdown-menu'
import { type ReactNode } from 'react'

export const menuItemClass =
  'flex h-8 cursor-default items-center gap-2 rounded-sm px-2 text-[13px] outline-none select-none data-highlighted:bg-surface-2'

export function MenuContent({
  children,
  onCloseAutoFocus,
}: {
  children: ReactNode
  /** Call `e.preventDefault()` to keep focus where an item moved it (e.g. an inline editor). */
  onCloseAutoFocus?: (e: Event) => void
}) {
  return (
    <Menu.Portal>
      <Menu.Content
        align="end"
        sideOffset={6}
        {...(onCloseAutoFocus && { onCloseAutoFocus })}
        className="z-50 min-w-52 origin-(--radix-dropdown-menu-content-transform-origin) rounded-lg border border-line bg-surface p-1 shadow-lg data-[state=open]:animate-[menu-in_160ms_var(--ease-spring)]"
      >
        {children}
      </Menu.Content>
    </Menu.Portal>
  )
}
